$( document ).ready(function() {
	if($('.brochure').length) {
		$('.brochure img').addClass('img-responsive');
	}
});
